import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
	// we init with resources
	resources: {
		es: {
			translations: {
				'common.alsea': 'Alsea',
				'layout.menu.who_we_are': 'Nosotros',
				'layout.menu.trademark': 'Nuestras Marcas',
				'layout.menu.areas': 'Áreas',
				'layout.menu.office': 'Office Tour',
				'layout.menu.sustentabilidad': 'Sustentabilidad',
				'layout.menu.testimonials': 'Testimonios',
				'layout.menu.benefits': 'Beneficios',
				'layout.menu.opportunities': 'OFertas Laborales',
				'home.herosection.title': 'Haz parte de nuestra cultura única',
				'home.weare.title1': 'Quiénes ',
				'home.weare.title2': 'somos',
				'home.weare.intro1': 'Somos un Holding Mexicano, operador de restaurantes líder en ',
				'home.weare.intro2': 'América Latina ',
				'home.weare.intro3': 'y ',
				'home.weare.intro4': 'España.',
				'home.weare.intro5': 'Tenemos presencia en ',
				'home.weare.intro6': '11 países ',
				'home.weare.intro7': 'y operamos ',
				'home.weare.intro8': '14 marcas a nivel mundial.',
				'home.weare.trademarks': 'Nuestras marcas en Chile:',
				'home.purpose.title': 'Nuestro propósito es...',
				'home.purpose.subtitle': '¡Encender el espíritu de la gente!',
				'home.segments.title': 'Segmentos',
				'home.segments.segment_1': 'Restaurantes de Servicio Rápido',
				'home.segments.segment_2': 'Cafeterías',
				'home.segments.segment_3': 'Restaurantes de Comida Casual',
				'home.segments.segment_4': 'Restaurantes Familiares',
				'home.values.title': 'Valores Alsea',
				'home.values.value_1': 'Actitud Ganadora',
				'home.values.value_1_exp': '<strong>Demostrar pasión por la excelencia</strong> que nos motiva a bscar soluciones integrales y a alcanzar ,etas cada vez más altas para maximizar resultados.',
				'home.values.value_2': 'Liderazgo Involucrado',
				'home.values.value_2_exp': '<strong> Cuidar mi Negocio</strong> como a mi casa, a mi Equipo como a mi familia ya al Cliente como el invitado que es.',
				'home.values.value_3': 'Servicio Sorprendente',
				'home.values.value_3_exp': 'Elevar constantemente los estándares de satisfacción para <strong>contagiar nuestra pasión</strong> por servir y sorprender.',
				'home.values.value_4': 'Espíritu Colaborativo',
				'home.values.value_4_exp': '<strong>Sumar ideas y talento</strong> para crear la comunidad participativa que se ayuda ante los retos y multiplica el valor de los resultados.',
				'home.values.value_5': 'Atención al Detalle',
				'home.values.value_5_exp': 'Buscamos siempre la mejora continua para entregar una <strong>ejecución impecable</strong> que fortalezca el valor de la experiencia Alsea.',
				'home.areas.title': 'Nuestras Áreas',
				'home.recruitment.title': 'Proceso de Reclutamiento y Selección',
				'home.recruitment.subtitle': 'Si quieres ser un Alseano, ésta es la forma en que Reclutamos y Seleccionamos Talentos.',
				'home.recruitment.step1': 'Publicamos la Oferta Laboral',
				'home.recruitment.step2': 'Filtramos los CV',
				'home.recruitment.step3': 'Aplicamos pruebas online',
				'home.recruitment.step4': 'Realizamos entrevistas por competencias',
				'home.recruitment.step5': 'Entrevista con jefatura del cargo',
				'home.recruitment.step6': 'Realizamos la oferta al candidato más idóneo al cargo',
				'home.inclusion.title': 'Inclusión y Diversidad',
				'home.inclusion.talent.title': 'Talento cómo base',
				'home.inclusion.talent.desc': 'En Alsea creemos que el Talento está en todos partes y que todos tenemos algo que aportar, para hacer de nuestra organización, el mejor lugar para trabajar. Es por esto que velamos por tener un grupo diverso de colaboradores, y aportar a la inclusión de cuatro grupos prioritarios: personas en situación de discapacidad, migrantes, jóvenes en situación vulnerable y adultos mayores.',
				'home.inclusion.inclusion.title': 'Miembros de Pride Connection',
				'home.inclusion.inclusion.desc': 'En Alsea y nuestras marcas estamos comprometidos con ser una empresa diversa e inclusiva en todos los ámbitos. Es por esto que desde este 2020 formamos parte de Pride Connection, de la Fundación Iguales, la cual busca promover espacios de trabajo inclusivos para la diversidad sexual y generar lazos para la atracción de talento LGBT.',
				'home.testimonials.title': 'Testimonios',
				'home.testimonials.line1_up': '(Ingresó el 2018 con el cargo de Analista de Gestión de Talento y actualmente se desempeña como Analista de Gestión de Talento Sr.).',
				'home.testimonials.line1_down': '“Lo que más me gusta de trabajar en Alsea es el dinamismo que tienes en el día a día, el aprendizaje constante, y la autonomía que tienes para proponer ideas, realizar las cosas de manera distinta, y con ellas agregar valor al negocio. Si tienes alguna propuesta de mejora en un proceso o algo distinto que aportar, lo tomas como propio, y te empoderas en su desarrollo, siempre va a ser bienvenido, impulsando con ello tu liderazgo y crecimiento profesional”',
				'home.testimonials.line2_up': '(Ingresó el 2016 con el cargo de Analista de Control de Gestión, luego asumió el cargo de Analista Business Intelligence para Starbucks y actualmente es Jefe Business Intelligence).',
				'home.testimonials.line2_down': '“Lo que motivó a querer trabajar en Alsea es el grupo de marcas que opera Alsea en Chile y la oportunidad profesional de conocer distintos rubros del sector alimentos y cafés. Lo que más me gusta de trabajar en Alsea es la flexibilidad que existe para crear cosas nuevas y que estas ideas tengan valor para la organización”.',
				'home.testimonials.line3_up': '(Ingresó el 2016 realizando su práctica en el área de Calidad, luego obtuvo el cargo de Analista de Calidad, luego fue Coordinador de Calidad y actualmente está en el área de Marketing con el cargo de Analista de Medios y Digital para Burger King, PF Chang´s y Chili´s).',
				'home.testimonials.line3_down': '“En un comienzo entré como alumno en práctica conociendo un área totalmente nueva para mí, la Calidad de los alimentos. Al llegar me encontré con un gran equipo humano que me recibió cálidamente y con el cual hicimos y hemos un hecho un gran trabajo. Lo que más me gusta de trabajar en Alsea es que la compañía es muy dinámica, que permite trabajar y conectar constantemente con distintas áreas de la organización, fomentando mucho el trabajo en redes y en equipo”.',
			},
		},
	},
	fallbackLng: 'es',
	debug: true,

	// have a common namespace used around the full app
	ns: ['translations'],
	defaultNS: 'translations',

	keySeparator: false, // we use content as keys

	interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ',',
	},

	react: {
		wait: true,
	},
});

export default i18n;
